module.exports = __webpack_public_path__ + "img/warning.d12f8c71.png";